import React from 'react'
import SideBarBack from '../../components/SidebarBack'
import { useDispatch } from 'react-redux'
import {
    setDrawerActiveMenu,
} from '../../store/features/webUtilitiesSlice'


export default function Menu() {

    const dispatch = useDispatch()
    // const handleChangeSidebar = async menu => {
    //     await dispatch(setDrawerActiveMenu(menu))
    // }

    const handleCloseDrawer = async () => {
        await dispatch(setDrawerActiveMenu(32))
    }

    return (
        <div className='w-full h-full'>
            <div className='w-full flex mb-2'>
                <SideBarBack handleCloseDrawer={handleCloseDrawer} />
            </div>
            <div className='flex flex-col gap-2 mt-2 w-11/12 mx-auto pb-14'>
                <p className='text-2xl font-semibold mb-2 text-center'>Upgrade subscription</p>
                <div className='mt-0'>
                </div>
            </div>
        </div>
    )
}
